import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import Section from "@casino/legacy/client/shared/PageSection/Section";
import type { TournamentsSectionState } from "../../hooks/useTournaments/TournamentsSectionState";
import useTournaments from "../../hooks/useTournaments/useTournaments";
import TournamentEmptyState from "../../modules/TournamentLists/TournamentEmptyState";
import TournamentCard from "../../shared/TournamentCard";
import TournamentCarousel from "../TournamentCarousel";

type Props = {
  status?: TournamentStatus;
  dataTestId?: string;
  onlyMine?: boolean;
  first?: number;
  page?: "home" | "list" | "details";
  initial?: TournamentsSectionState;
};

const TournamentSection: LazyFC<Props> = ({
  status,
  onlyMine,
  first,
  dataTestId,
  initial,
}) => {
  const { tournaments, totalCount, loading } = useTournaments({
    first,
    status,
    onlyMine,
    initial,
  });

  const { isMobile } = useAgentData();

  if (onlyMine && !totalCount) {
    return null;
  }

  if (!loading && !totalCount) {
    return <TournamentEmptyState status={status} onlyMine={onlyMine} />;
  }

  const items =
    tournaments?.map(({ node }) => (
      <TournamentCard
        device={isMobile ? "mobile" : "desktop"}
        key={node?.id}
        tournament={node}
        page="list"
      />
    )) ?? [];

  return (
    <Section testId={dataTestId}>
      <TournamentCarousel
        status={status}
        totalCount={totalCount}
        items={items}
        placeholder={{ enabled: loading }}
        onlyMine={onlyMine}
        reelClassName="gap-4"
      />
    </Section>
  );
};

export default TournamentSection;
